import { call, put, takeLatest, fork, all } from "redux-saga/effects";
import * as Types from "../constants/Types";
import * as Func from "../helpers/functions";
import * as cacheRedisActions from "../actions/cacheRedisAction";
import * as cacheRedisService from "../services/cacheRedisService";
import i18n from '../constants/initLng';

function* getRedisCacheKeys() {
  yield takeLatest(
    Types.CACHE_LIST_ACTION,
    Func.sagaWrapper(function* (action) {
      const result = yield call(cacheRedisService.getRedisCache);
      yield put(cacheRedisActions.setRedisKeyAction(result));
    }, errorHandleReport(Types.CACHE_LIST_FAIL))
  );
}

function* deleteRedisKey() {
  yield takeLatest(
    Types.CACHE_DELETE_ACTION,
    Func.sagaWrapper(function* (action) {
      const result = yield call(
        cacheRedisService.deleteRedisCache,
        action.params
      );
      Func.sagaSuccessMessage(action, `${i18n.t('notification.clearCacheSuccess')}`);
      yield put({ type: Types.CACHE_DELETE_SUCCESS });
    }, errorHandleReport(Types.CACHE_DELETE_FAIL))
  );
}

function errorHandleReport(errorActionType) {
  return Func.sagaErrorHandler(function* (e) {
    yield put({ type: errorActionType });
  }, "cacheRedis");
}

export function* cacheRedisSaga() {
  yield all([fork(getRedisCacheKeys), fork(deleteRedisKey)]);
}
